import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../hooks/useTheme';
import { usersApi } from '../api/users';
import './ForgotPassword.css';

function ForgotPassword() {
	const { isDarkMode } = useTheme();
	const navigate = useNavigate();
	const [step, setStep] = useState('email'); // 'email' or 'verify'
	const [email, setEmail] = useState('');
	const [code, setCode] = useState('');
	const [newPassword, setNewPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState('');
	const [success, setSuccess] = useState(false);

	const handleEmailSubmit = async (e) => {
		e.preventDefault();
		setError('');
		setIsLoading(true);

		try {
			await usersApi.sendPasswordResetEmail(email);
			setStep('verify');
		} catch (error) {
			setError(
				error.message || 'Failed to send reset email. Please try again.'
			);
		} finally {
			setIsLoading(false);
		}
	};

	const handleResetSubmit = async (e) => {
		e.preventDefault();
		setError('');

		// Validate passwords match
		if (newPassword !== confirmPassword) {
			setError('Passwords do not match');
			return;
		}

		// Validate password length
		if (newPassword.length < 8) {
			setError('Password must be at least 8 characters long');
			return;
		}

		setIsLoading(true);

		try {
			await usersApi.resetPassword(email, code, newPassword);
			setSuccess(true);
		} catch (error) {
			setError(
				error.message || 'Failed to reset password. Please try again.'
			);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className='dashboard-login'>
			<div className='login-container'>
				<img
					src={require(`../assets/${
						isDarkMode ? 'Icon_Gradient' : 'Icon_Primary'
					}.png`)}
					alt='Assemblie Logo'
					className='login-logo'
				/>

				{error && <div className='error-message'>{error}</div>}

				{success ? (
					<div className='success-message'>
						<h2>Password Reset Successful</h2>
						<p>Your password has been successfully reset.</p>
						<button
							className='sign-in-btn'
							onClick={() => navigate('/dashboard/login')}>
							Return to Login
						</button>
					</div>
				) : (
					<>
						<h2>
							{step === 'email'
								? 'Reset Password'
								: 'Enter Reset Code'}
						</h2>
						<p className='reset-instructions'>
							{step === 'email'
								? "Enter your email address and we'll send you a reset code."
								: 'Enter the 6-digit code sent to your email and your new password.'}
						</p>

						<form
							className='login-form'
							onSubmit={
								step === 'email'
									? handleEmailSubmit
									: handleResetSubmit
							}>
							{step === 'email' ? (
								<input
									type='email'
									placeholder='Email'
									className='login-input'
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									required
								/>
							) : (
								<>
									<input
										type='text'
										placeholder='6-digit code'
										className='login-input'
										value={code}
										onChange={(e) =>
											setCode(e.target.value)
										}
										maxLength='6'
										required
									/>
									<input
										type='password'
										placeholder='New password'
										className='login-input'
										value={newPassword}
										onChange={(e) =>
											setNewPassword(e.target.value)
										}
										minLength='8'
										required
									/>
									<input
										type='password'
										placeholder='Confirm new password'
										className='login-input'
										value={confirmPassword}
										onChange={(e) =>
											setConfirmPassword(e.target.value)
										}
										minLength='8'
										required
									/>
									<p className='password-requirements'>
										Password must be at least 8 characters
										long
									</p>
								</>
							)}

							<button
								type='submit'
								className='sign-in-btn'
								disabled={isLoading}>
								{isLoading ? (
									<div className='loader'></div>
								) : step === 'email' ? (
									'Send Reset Code'
								) : (
									'Reset Password'
								)}
							</button>
						</form>

						<button
							className='back-to-login'
							onClick={() =>
								step === 'email'
									? navigate('/login')
									: setStep('email')
							}>
							{step === 'email'
								? 'Back to Login'
								: 'Back to Email'}
						</button>
					</>
				)}
			</div>
		</div>
	);
}

export default ForgotPassword;
